var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53.57 13.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0cbc41;}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Logo",
    "data-name": "Logo",
    viewBox: "0 0 53.57 13.12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 53.57,
    height: 13.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.37,
    y: 0.36,
    width: 10.71,
    height: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59,6.32c-.06,0-.08-.05-.05-.09a2.83,2.83,0,0,0,.18-2.91,1.33,1.33,0,0,0-.51-.45,1.9,1.9,0,0,0-.82-.23H2.59a.59.59,0,0,0-.19,0,.62.62,0,0,0-.6.65V9.83a.65.65,0,0,0,.65.65h5A2.38,2.38,0,0,0,9.16,10,2.61,2.61,0,0,0,8.59,6.32ZM8,9H3.25v-5H7.38c.11,0,.23.13.21.62A1.09,1.09,0,0,1,6.48,5.82H3.81V7.31H7.32a1,1,0,0,1,.8.64C8.37,8.77,8.23,9,8,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.67,6.41s-.05,0,0-.07a2.08,2.08,0,0,0,.13-2.15,1,1,0,0,0-.37-.33,1.48,1.48,0,0,0-.61-.18H14.1a.47.47,0,0,0-.44.48V9a.47.47,0,0,0,.47.48h3.68a1.77,1.77,0,0,0,1.29-.35A1.92,1.92,0,0,0,18.67,6.41Zm-.47,2H14.73V4.73h3.05c.08,0,.17.1.15.46a.8.8,0,0,1-.82.85h-2v1.1h2.6a.76.76,0,0,1,.59.47C18.51,8.22,18.38,8.41,18.2,8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.83,6h3.33v1.1H21.83Zm3.78,2.37h-3.8a.34.34,0,0,1-.39-.31V4.73h4.19V3.68H20.79a.47.47,0,0,0-.44.48V8.06a1.35,1.35,0,0,0,1.3,1.42h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.73,9.51V4.73h4.19V3.68H40.1a.47.47,0,0,0-.44.48V9.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.14,
    y: 6.04,
    width: 3.33,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.87 3.68 26.2 3.68 26.2 4.71 28.53 4.71 28.53 9.49 29.54 9.49 29.54 4.71 31.87 4.71 31.87 3.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.01 3.68 45.35 3.68 45.35 4.71 47.67 4.71 47.67 9.49 48.68 9.49 48.68 4.71 51.01 4.71 51.01 3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.37,3.61V7.66L33.62,3.81a.59.59,0,0,0-.46-.21.52.52,0,0,0-.54.46,2.53,2.53,0,0,0,0,.29V9.49h1.1v-4l3.76,3.87,0,0,.09.09v0a.54.54,0,0,0,.31.09A.58.58,0,0,0,38.47,9h0V3.61Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("use", {
    width: 53.57,
    height: 13.12,
    xlinkHref: "#Logo"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b7e3afbd520d454f19def4b670b5259.svg";
export { ForwardRef as ReactComponent };